import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/compliance/runs/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/compliance',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
